<template>
  <div
    class="flex-none"
    v-if="!$store.getters['ADMIN/isLoggedAdminIn']"
  >
    <div class="mr-3">
      <div class="dropdown dropdown-end">
        <div
          tabindex="0"
          class=""
        >
          <div
            v-if="$store.getters['USER/isLoggedIn']"
            class="mr-3 avatar placeholder"
          >
            <svg
              width="49"
              height="32"
              viewBox="0 0 49 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.9777 14H48.0183C48.5746 14 48.8527 14.6719 48.4589 15.0656L44.4402 19.0875C44.1964 19.3312 43.7996 19.3312 43.5558 19.0875L39.5371 15.0656C39.1433 14.6719 39.4214 14 39.9777 14Z"
                fill="#4B5563"
              />
              <g clip-path="url(#clip0_270_516)">
                <path
                  d="M15.5 0.5C6.9375 0.5 0 7.4375 0 16C0 24.5625 6.9375 31.5 15.5 31.5C24.0625 31.5 31 24.5625 31 16C31 7.4375 24.0625 0.5 15.5 0.5ZM15.5 6.5C18.5375 6.5 21 8.9625 21 12C21 15.0375 18.5375 17.5 15.5 17.5C12.4625 17.5 10 15.0375 10 12C10 8.9625 12.4625 6.5 15.5 6.5ZM15.5 28C11.8313 28 8.54375 26.3375 6.34375 23.7375C7.51875 21.525 9.81875 20 12.5 20C12.65 20 12.8 20.025 12.9438 20.0688C13.7563 20.3313 14.6062 20.5 15.5 20.5C16.3937 20.5 17.25 20.3313 18.0562 20.0688C18.2 20.025 18.35 20 18.5 20C21.1812 20 23.4813 21.525 24.6562 23.7375C22.4562 26.3375 19.1688 28 15.5 28Z"
                  fill="#425664"
                />
              </g>
              <defs>
                <clipPath id="clip0_270_516">
                  <rect
                    width="31"
                    height="32"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div v-else>
            <svg
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
          </div>
        </div>
        <div
          tabindex="0"
          class="bg-white shadow dropdown-content rounded-box w-max p-4 z-20"
        >
          <div
            class="list-wrap"
            v-if="$store.getters['USER/isLoggedIn']"
          >
            <div class="list-row neutral-grays-700 text-sm font-medium flex mt-1 mb-1 p-2 item-center cursor-pointer">
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.17708 1.45139C1.7765 1.45139 1.45139 1.7765 1.45139 2.17708V15.2396C1.45139 15.6402 1.7765 15.9653 2.17708 15.9653H10.8854C11.286 15.9653 11.6111 15.6402 11.6111 15.2396V6.53125H8.70833C7.50586 6.53125 6.53125 5.55664 6.53125 4.35417V1.45139H2.17708ZM7.98264 2.47752L10.585 5.07986H8.70833C8.30775 5.07986 7.98264 4.75475 7.98264 4.35417V2.47752ZM0 2.17708C0 0.974608 0.974608 0 2.17708 0H7.25694C7.44925 0 7.63431 0.0761979 7.77001 0.212628L12.8499 5.29249C12.9863 5.42819 13.0625 5.61325 13.0625 5.80556V15.2396C13.0625 16.4421 12.0879 17.4167 10.8854 17.4167H2.17708C0.974608 17.4167 0 16.4421 0 15.2396V2.17708ZM3.62847 10.1597C3.62847 9.75914 3.95358 9.43403 4.35417 9.43403H6.53125C6.93183 9.43403 7.25694 9.75914 7.25694 10.1597C7.25694 10.5603 6.93183 10.8854 6.53125 10.8854H4.35417C3.95358 10.8854 3.62847 10.5603 3.62847 10.1597ZM3.62847 13.0625C3.62847 12.6619 3.95358 12.3368 4.35417 12.3368H8.70833C9.10892 12.3368 9.43403 12.6619 9.43403 13.0625C9.43403 13.4631 9.10892 13.7882 8.70833 13.7882H4.35417C3.95358 13.7882 3.62847 13.4631 3.62847 13.0625Z"
                  fill="#4B5563"
                />
              </svg>
              <router-link
                v-if="isLoggedIn && !$store.getters['ADMIN/isLoggedAdminIn']"
                :to="{name:'Profile'}"
                class="link-hover"
              >
                My profile
              </router-link>
            </div>
            <div
              class="list-row neutral-grays-700 text-sm font-medium flex mt-1 mb-1 p-2 item-center"
              v-if="$store.state.USER.user.role == 'admin'"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9334 11.5333C13.7334 11.5333 15.1334 10.0666 15.1334 8.26665C15.1334 6.46665 13.6667 5.06665 11.8667 5.06665C10.0667 5.06665 8.66675 6.53332 8.66675 8.26665C8.66675 10.0666 10.1334 11.5333 11.9334 11.5333ZM11.8667 6.39998C11.9334 6.39998 11.9334 6.39998 11.8667 6.39998C12.9334 6.39998 13.8001 7.26665 13.8001 8.33332C13.8001 9.39998 12.9334 10.2 11.8667 10.2C10.8001 10.2 10.0001 9.33332 10.0001 8.33332C10.0001 7.26665 10.8667 6.39998 11.8667 6.39998Z"
                  fill="#4B5563"
                />
                <path
                  d="M21.8 11.1334C20.5333 10 18.8667 9.40002 17.1333 9.46669H16.6C16.4667 10 16.2667 10.4667 16 10.8667C16.4 10.8 16.7333 10.8 17.1333 10.8C18.4 10.7334 19.6667 11.1334 20.6667 11.8667V16.6667H22V11.3334L21.8 11.1334Z"
                  fill="#4B5563"
                />
                <path
                  d="M15.6001 5.19997C15.9334 4.39997 16.8667 3.99997 17.7334 4.3333C18.5334 4.66664 18.9334 5.59997 18.6001 6.46664C18.3334 7.06664 17.7334 7.46664 17.1334 7.46664C17.0001 7.46664 16.8001 7.46664 16.6667 7.39997C16.7334 7.7333 16.7334 8.06664 16.7334 8.3333V8.7333C16.8667 8.7333 17.0001 8.79997 17.1334 8.79997C18.8001 8.79997 20.1334 7.46664 20.1334 5.86664C20.1334 4.19997 18.8001 2.86664 17.2001 2.86664C16.1334 2.86664 15.2001 3.39997 14.6667 4.3333C15.0001 4.5333 15.3334 4.79997 15.6001 5.19997Z"
                  fill="#4B5563"
                />
                <path
                  d="M8 10.9333C7.73333 10.5333 7.53333 10.0667 7.4 9.53335H6.86667C5.13333 9.46668 3.46667 10.0667 2.2 11.1333L2 11.3333V16.6667H3.33333V11.8667C4.4 11.1333 5.6 10.7333 6.86667 10.8C7.26667 10.8 7.66667 10.8667 8 10.9333Z"
                  fill="#4B5563"
                />
                <path
                  d="M6.86668 8.73336C7.00001 8.73336 7.13334 8.73336 7.26667 8.66669V8.26669C7.26667 7.93336 7.26668 7.60003 7.33334 7.33336C7.20001 7.40002 7.00001 7.40003 6.86668 7.40003C6.00001 7.40003 5.26668 6.66669 5.26668 5.80002C5.26668 4.93336 6.00001 4.20003 6.86668 4.20003C7.53334 4.20003 8.13334 4.60003 8.40001 5.20003C8.66668 4.86669 9.06668 4.53336 9.40001 4.26669C8.53334 2.86669 6.73334 2.40003 5.33334 3.26669C3.93334 4.13336 3.46668 5.93336 4.33334 7.33336C4.86668 8.20003 5.80001 8.73336 6.86668 8.73336Z"
                  fill="#4B5563"
                />
                <path
                  d="M17.4001 15.1333L17.2667 14.9333C15.9334 13.4667 14.0667 12.6 12.0667 12.6667C10.0667 12.6 8.13341 13.4667 6.80008 14.9333L6.66675 15.1333V20.2C6.66675 20.8 7.13341 21.3333 7.80008 21.3333H16.3334C16.9334 21.3333 17.4667 20.8 17.4667 20.2V15.1333H17.4001ZM16.0667 20H8.00008V15.6C9.06675 14.5333 10.5334 14 12.0667 14C13.5334 13.9333 15.0001 14.5333 16.0667 15.6V20Z"
                  fill="#4B5563"
                />
              </svg>
              <router-link
                class="link-hover"
                :to="{name:'Organisation'}"
              >
                Manage Users
              </router-link>
            </div>
            <div class="list-row neutral-grays-700 text-sm font-medium flex mt-1 mb-1 p-2 item-center cursor-pointer">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.3072 4.5C12.1197 4.5 11.9329 4.50675 11.7484 4.52025C11.5257 4.53675 11.2894 4.731 11.2407 5.06775L11.1694 5.5575C11.0472 6.4005 10.4689 7.02675 9.82618 7.37175C9.72943 7.4235 9.63493 7.479 9.54193 7.536C8.92093 7.92225 8.08918 8.10975 7.29793 7.794L6.83743 7.61025C6.52093 7.48425 6.23518 7.59075 6.10843 7.776C5.89918 8.08275 5.71168 8.406 5.54893 8.74425C5.45143 8.94525 5.50168 9.24525 5.76868 9.456L6.16093 9.76575C6.82843 10.2922 7.08268 11.1045 7.05943 11.8342L7.05718 12L7.05943 12.1658C7.08268 12.8955 6.82843 13.7078 6.16093 14.2343L5.76868 14.544C5.50168 14.7547 5.45143 15.0547 5.54893 15.2557C5.71168 15.594 5.89918 15.9172 6.10843 16.224C6.23518 16.4093 6.52093 16.5157 6.83743 16.3897L7.29793 16.206C8.08918 15.8903 8.92093 16.0785 9.54193 16.464C9.63493 16.521 9.72943 16.5765 9.82618 16.6283C10.4689 16.9733 11.0472 17.5995 11.1694 18.4425L11.2407 18.9323C11.2894 19.269 11.5257 19.4632 11.7484 19.4797C11.9329 19.4932 12.1197 19.5 12.3072 19.5C12.4947 19.5 12.6814 19.4932 12.8659 19.4797C13.0894 19.4632 13.3249 19.269 13.3737 18.9323L13.4449 18.4425C13.5672 17.5995 14.1454 16.9733 14.7882 16.6283C14.8849 16.5765 14.9794 16.521 15.0732 16.464C15.6934 16.0785 16.5252 15.8903 17.3164 16.206L17.7769 16.3897C18.0934 16.5157 18.3792 16.4093 18.5059 16.224C18.7152 15.9172 18.9027 15.5932 19.0654 15.2557C19.1629 15.0547 19.1127 14.7547 18.8457 14.544L18.4534 14.2343C17.7859 13.7078 17.5317 12.8955 17.5549 12.1658L17.5572 12L17.5549 11.8342C17.5317 11.1045 17.7859 10.2922 18.4534 9.76575L18.8457 9.456C19.1127 9.24525 19.1629 8.94525 19.0654 8.74425C18.9027 8.40675 18.7152 8.08275 18.5059 7.776C18.3792 7.59075 18.0934 7.48425 17.7769 7.61025L17.3164 7.794C16.5252 8.10975 15.6934 7.92225 15.0732 7.536C14.9794 7.479 14.8849 7.4235 14.7882 7.37175C14.1454 7.02675 13.5672 6.4005 13.4449 5.5575L13.3737 5.06775C13.3249 4.731 13.0894 4.53675 12.8659 4.52025C12.6814 4.50675 12.4947 4.5 12.3072 4.5ZM11.6389 3.02475C11.8594 3.00825 12.0822 3 12.3072 3C12.5322 3 12.7549 3.00825 12.9754 3.02475C14.0142 3.1005 14.7252 3.9375 14.8579 4.8525L14.9292 5.34225C14.9667 5.60025 15.1602 5.86875 15.4977 6.05025C15.6222 6.117 15.7444 6.1875 15.8637 6.2625C16.1892 6.46425 16.5184 6.49725 16.7607 6.4005L17.2219 6.21675C18.0792 5.87475 19.1577 6.072 19.7442 6.93C19.9954 7.29825 20.2212 7.68675 20.4169 8.09175C20.8692 9.02925 20.4994 10.0628 19.7742 10.6343L19.3827 10.9433C19.1779 11.1045 19.0422 11.406 19.0542 11.7878C19.0564 11.8583 19.0572 11.9288 19.0572 12C19.0572 12.0712 19.0564 12.1417 19.0542 12.2122C19.0422 12.594 19.1779 12.8955 19.3827 13.0568L19.7742 13.3658C20.4994 13.9373 20.8692 14.9707 20.4169 15.9082C20.2212 16.3132 19.9954 16.7017 19.7442 17.07C19.1577 17.928 18.0792 18.1252 17.2219 17.7832L16.7607 17.5995C16.5184 17.5027 16.1892 17.5358 15.8637 17.7375C15.7444 17.8125 15.6222 17.883 15.4977 17.9497C15.1602 18.1313 14.9667 18.3997 14.9292 18.6578L14.8579 19.1475C14.7252 20.0625 14.0142 20.8995 12.9754 20.9753C12.7549 20.9918 12.5322 21 12.3072 21C12.0822 21 11.8594 20.9918 11.6389 20.9753C10.6009 20.8995 9.88918 20.0625 9.75643 19.1475L9.68518 18.6578C9.64768 18.3997 9.45418 18.1313 9.11668 17.9497C8.99218 17.883 8.86993 17.8125 8.75068 17.7375C8.42518 17.5358 8.09593 17.5027 7.85368 17.5995L7.39243 17.7832C6.53518 18.1252 5.45668 17.928 4.87018 17.07C4.61893 16.7017 4.39318 16.3132 4.19818 15.9082C3.74518 14.9707 4.11493 13.9373 4.84018 13.3658L5.23168 13.0568C5.43643 12.8955 5.57218 12.594 5.56018 12.2122C5.55793 12.1417 5.55718 12.0712 5.55718 12C5.55718 11.9288 5.55793 11.8583 5.56018 11.7878C5.57218 11.406 5.43643 11.1045 5.23168 10.9433L4.84018 10.6343C4.11493 10.0628 3.74518 9.02925 4.19818 8.09175C4.39318 7.68675 4.61893 7.29825 4.87018 6.93C5.45668 6.072 6.53518 5.87475 7.39243 6.21675L7.85368 6.4005C8.09593 6.49725 8.42518 6.46425 8.75068 6.2625C8.86993 6.1875 8.99218 6.117 9.11668 6.05025C9.45418 5.86875 9.64768 5.60025 9.68518 5.34225L9.75643 4.8525C9.88918 3.9375 10.6009 3.1005 11.6389 3.02475ZM12.3072 9.75C11.0644 9.75 10.0572 10.7572 10.0572 12C10.0572 13.2428 11.0644 14.25 12.3072 14.25C13.5499 14.25 14.5572 13.2428 14.5572 12C14.5572 10.7572 13.5499 9.75 12.3072 9.75ZM8.55718 12C8.55718 9.92925 10.2357 8.25 12.3072 8.25C14.3779 8.25 16.0572 9.92925 16.0572 12C16.0572 14.0708 14.3779 15.75 12.3072 15.75C10.2357 15.75 8.55718 14.0708 8.55718 12Z"
                  fill="#4B5563"
                />
              </svg>
              <router-link
                v-if="isLoggedIn && !$store.getters['ADMIN/isLoggedAdminIn']"
                to="/login/change"
                class="link-hover"
              >
                Change Password
              </router-link>
            </div>
            <div
              class="list-row neutral-grays-700 text-sm font-medium flex mt-1 mb-1 p-2 item-center cursor-pointer link-hover"
            >
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.3383 5.20626C15.9117 4.19029 15.2911 3.26685 14.5111 2.4874C13.7334 1.7066 12.8097 1.08581 11.7922 0.660285C10.7499 0.222253 9.63005 -0.00228124 8.49911 1.7473e-05H8.46108C7.31078 0.00570943 6.1985 0.233388 5.15087 0.681155C4.14216 1.11104 3.22705 1.73293 2.45669 2.51207C1.68423 3.28977 1.07075 4.20998 0.650423 5.22144C0.214097 6.27324 -0.00699178 7.40151 0.000168518 8.53985C0.00587251 9.85659 0.321493 11.1638 0.910905 12.3326V15.2165C0.910905 15.6984 1.30258 16.0893 1.78362 16.0893H4.66983C5.84652 16.6818 7.145 16.9935 8.46299 17H8.50291C9.63991 17 10.7408 16.7799 11.7789 16.3492C12.7912 15.9288 13.7115 15.3152 14.4883 14.543C15.2716 13.767 15.8877 12.86 16.3193 11.8488C16.7661 10.8015 16.9942 9.68773 17 8.53795C17.0038 7.38249 16.7794 6.26117 16.3383 5.20626ZM4.70406 9.41072C4.20211 9.41072 3.79332 9.0028 3.79332 8.50001C3.79332 7.99722 4.20211 7.58929 4.70406 7.58929C5.20601 7.58929 5.61479 7.99722 5.61479 8.50001C5.61479 9.0028 5.20791 9.41072 4.70406 9.41072ZM8.49911 9.41072C7.99716 9.41072 7.58837 9.0028 7.58837 8.50001C7.58837 7.99722 7.99716 7.58929 8.49911 7.58929C9.00106 7.58929 9.40985 7.99722 9.40985 8.50001C9.40985 9.0028 9.00106 9.41072 8.49911 9.41072ZM12.2942 9.41072C11.7922 9.41072 11.3834 9.0028 11.3834 8.50001C11.3834 7.99722 11.7922 7.58929 12.2942 7.58929C12.7961 7.58929 13.2049 7.99722 13.2049 8.50001C13.2049 9.0028 12.7961 9.41072 12.2942 9.41072Z"
                  fill="#4B5563"
                />
              </svg>
              <label
                class=" cursor-pointer hover:underline"
                @click="openChatbot()"
              >  Talk to Specialist</label>
            </div>
            <div class="list-row neutral-grays-700 text-sm font-medium flex mt-1 mb-1 p-2 item-center cursor-pointer">
              <svg
                width="15"
                height="17"
                viewBox="0 0 15 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.2499 0.916666C8.2499 0.673551 8.15332 0.440394 7.98142 0.268485C7.80951 0.0965771 7.57635 0 7.33324 0C7.09012 0 6.85696 0.0965771 6.68505 0.268485C6.51315 0.440394 6.41657 0.673551 6.41657 0.916666L6.41382 8.25275C6.41382 8.49586 6.5104 8.72902 6.6823 8.90093C6.85421 9.07284 7.08737 9.16942 7.33048 9.16942C7.5736 9.16942 7.80676 9.07284 7.97867 8.90093C8.15057 8.72902 8.24715 8.49586 8.24715 8.25275L8.2499 0.917583V0.916666Z"
                  fill="#4B5563"
                />
                <path
                  d="M0 9.15108C0 7.12525 0.820417 5.29192 2.14775 3.9655L3.44392 5.26167C2.67469 6.03084 2.15083 7.01085 1.93858 8.07775C1.72633 9.14466 1.83523 10.2505 2.2515 11.2556C2.66777 12.2606 3.37272 13.1196 4.2772 13.7239C5.18168 14.3283 6.24506 14.6509 7.33288 14.6509C8.42069 14.6509 9.48407 14.3283 10.3885 13.7239C11.293 13.1196 11.998 12.2606 12.4142 11.2556C12.8305 10.2505 12.9394 9.14466 12.7272 8.07775C12.5149 7.01085 11.9911 6.03084 11.2218 5.26167L12.5189 3.9655C13.3716 4.81826 14.0009 5.86816 14.3509 7.02219C14.701 8.17622 14.761 9.39877 14.5257 10.5816C14.2905 11.7643 13.7671 12.8708 13.0021 13.803C12.237 14.7353 11.2539 15.4644 10.1397 15.9259C9.02556 16.3874 7.81479 16.567 6.61464 16.4488C5.41449 16.3307 4.26201 15.9183 3.25928 15.2483C2.25655 14.5784 1.43452 13.6715 0.86601 12.6079C0.297496 11.5444 4.39435e-05 10.357 0 9.15108Z"
                  fill="#4B5563"
                />
              </svg>
              <login-button class="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginButton from './TheLoginButton.vue'

import { mapGetters } from 'vuex'
export default {
  components: {
    LoginButton
  },
  computed: {
    ...mapGetters({ order: 'ORDER/getOrder', isLoggedIn: 'USER/isLoggedIn', subscription: 'USER/getSubscription' })
  },

  methods: {

    openChargbeePortal () {
      this.$chargebee.setPortalSession(() => {
        return this.$api.getChargebeePortalSession()
      })

      const chargbebeePortal = this.$chargebee.createChargebeePortal()
      chargbebeePortal.open({
        close: () => {
          this.$chargebee.logout()
        }
      })
    },
    openChatbot () {
      this.$crisp.chat.open()
      this.$crisp.message.send('text', 'Hello I need help!')
    }

  }

}
</script>

<style lang="scss">
@import "./theprofile.scss";
</style>
